import { render, staticRenderFns } from "./BasketPreview.vue?vue&type=template&id=24aabaad&scoped=true&"
import script from "./BasketPreview.vue?vue&type=script&lang=js&"
export * from "./BasketPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aabaad",
  null
  
)

export default component.exports